import {call, get} from "vuex-pathify";
import {BasicStep} from "../../../models/steps/BasicStep";
import {ButtonStep} from "../../../models/steps/ButtonStep";
import {KeyboardStep} from "../../../models/steps/KeyboardStep";
import {gsap} from "gsap";
import store from "../../../store";

export default {
    computed: {
        isBasicStep() {
            return this.step instanceof BasicStep
        },
        isButtonStep() {
            return this.step instanceof ButtonStep
        },
        isKeyboardStep() {
            return this.step instanceof KeyboardStep
        },
        loading:get('func_data/loading'),
        block_form:get('func_data/block_form'),
        resource_form: get('form/resource_form'),
        form: get('form/form'),
        errors: get('form/errors'),
        step: get('form/form@_steps.[:stepName]'),
        stepName() {
            return this.$route.params.step
        }
    },
    methods: {
        nextStep: call('form/goToNextStep'),
        goBack(){
            if(this.step._back_button){
                location.href= this.step._back_button;
            } else {
                this.$store.dispatch('form/goBack')
            }
        },
        goTo(step) {
            this.$store.dispatch('form/goTo', step)
                let steps_track = _.cloneDeep(this.$store.get('general_data/steps_track'));
                this.$store.set('general_data/steps_track', [...steps_track, step]);
                this.$store.set('form/printStepsLog', {step: step,type:'next'});
        }
    },
}
